import { Box, Button, DialogActions, Grid, TextField, makeStyles } from '@material-ui/core'
import React from 'react'
import { useQueryClient } from 'react-query'
import { useEditVendorMutation } from 'components/api'
import AdminModal from '../admin/AdminModal'
import { useValidation } from 'components'

const useStyles = makeStyles({
    root: {
        padding: 20
    },
    buttonContainer: {
        borderTop: '1px solid #dee2e6',
        paddingTop: 20
    },
    closeButton: {
        color: '#ef8c25'
    },
    inviteButton: {
        color: '#fff'
    }
})

function ActionButtons({ onSubmit, close }) {
    const classes = useStyles()
    return (
        <DialogActions>
            <Grid
                container
                className={classes.buttonContainer}
                justify="flex-end"
                spacing={2}
            >
                <Grid item>
                    <Button onClick={close} className={classes.closeButton}>
                        Close
                    </Button>
                </Grid>
            </Grid>
        </DialogActions>
    )
}
const renderEmail = (email_body) => {
    let body = ""
    try {
        body = email_body
        // body = body.replaceAll('<%= it.employee_name %>', '<b>EMPLOYEE NAME</b>')
        // body = body.replaceAll('<%= it.trust_metrics %>', '<b>XxXxXx</b>')
        // body = body.replaceAll('<%= it.spid %>', '<b>ABCD1234abcd123</b>')
        // body = body.replaceAll('<%= it.sp_id || "" %>', '<b>XXXXXXXXXXXX</b>')
        // body = body.replaceAll('<%= it.company_name %>', 'COMPANY NAME')
        body = body.replaceAll('<%= it.tenant_img %>', "https://s3.us-west-2.amazonaws.com/cdn.dataprotected.com/Logo.png")
        //body = body.replaceAll('<%=  %>', '')
    } catch (ex) {
        console.error({ ex })
        body = "!! Email body parse error !!"
    }
    return body

}

function ViewEmailModal(props, ref) {
    const queryClient = useQueryClient()
    const { mutateAsync: editVendorAsync } = useEditVendorMutation()
    const [open, setOpen] = React.useState(false)
    const [emailBody, setEmallBody] = React.useState("no body")
    const [values, setValues] = React.useState({
        vendor_name: '',
        contact_name: '',
        email: ''
    })

    React.useEffect(() => {
        let thebody = "Email missing or can't be decoded"
        try {
            thebody = decodeURIComponent(escape(window.atob(values.body)))
        } catch (error) {
            console.error("jonah")
            console.error({ error })
        }
        setEmallBody(thebody)
    }, [emailBody])
    const { validate, errors, ifError, reset: resetValidation } = useValidation(
        {
            vendor_name: 'required',
            contact_name: 'required',
            email: ['required', 'email']
        }
    )


    const onEditVendor = React.useCallback(
        async e => {
            e.preventDefault()

            if (!validate(values)) {
                return
            }
            try {
                await editVendorAsync({
                    email: values.email,
                    vendor_id: values.vendor_id,
                    vendor_name: values.vendor_name,
                    contact_name: values.contact_name
                })

                await queryClient.invalidateQueries('vendor-data')

                close()
            } catch (error) {
                throw error
            }
        },
        [values, editVendorAsync, queryClient, validate]
    )

    const close = React.useCallback(() => {
        setOpen(false)
    }, [])

    React.useImperativeHandle(ref, () => ({
        open: userInfo => {
            setValues(userInfo)
            setOpen(true)
        }
    }))

    const classes = useStyles()

    return (
        <AdminModal open={open} onClose={close} title={`${values?.email_type} - ${values?.language}`}>
    
    
            <Grid container xs={12} spacing={2} className={classes.root}>
                <Grid item xs={12}>
                    {values?.subject}
                </Grid>
                <Grid item xs={12}>
                    <Box component="section" sx={{ p: 2, border: '1px solid gray', overflow: 'hidden', overflowY: "scroll" }} height={540}>
                        {<div dangerouslySetInnerHTML={{ __html: renderEmail(emailBody) }} />}

                    </Box>
                </Grid>
            </Grid>
            <ActionButtons onSubmit={onEditVendor} close={close} />
        </AdminModal>
    )
}

export default React.forwardRef(ViewEmailModal)
